import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=acbb351a&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=acbb351a&prod&lang=scss&scoped=true"
import style1 from "./AppVersion.vue?vue&type=style&index=1&id=acbb351a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbb351a",
  null
  
)

export default component.exports